import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import kebabCase from 'lodash/fp/kebabCase';
import {
  getMarginBottomClass,
  marginBottomLevels,
} from '../../utils/marginBottom';
import { IconChevronDown, IconCloseThick, IconAddThick } from '../Icon';
import Reveal from '../Reveal';
import Theme from '../../utils/Theme';

import styles from './accordion-item.css';

export const AccordionItemType = {
  LARGE: 'large',
};

const AccordionItem = ({
  id,
  onToggle,
  expanded,
  type,
  title,
  iconSlot,
  children,
  marginBottom = 5,
  ...rest
}) => {
  id = id || kebabCase(title);

  const Icon = Theme.select({
    redbrand: IconChevronDown,
    mands: expanded ? IconCloseThick : IconAddThick,
  });

  return (
    <div
      className={cn(styles.item, {
        [styles['item--expanded']]: expanded,
      })}
    >
      <button
        className={cn(styles.toggleButton, {
          [styles[`toggleButton--${type}`]]: type,
          [styles['toggleButton--expanded']]: expanded,
          [styles['withIcon']]: iconSlot,
        })}
        type="button"
        aria-controls={`${id}-accordion-item`}
        aria-expanded={expanded}
        onClick={onToggle}
      >
        {iconSlot && <span className={styles.titleIcon}>{iconSlot}</span>}

        {title}

        <div className={styles.iconContainer}>
          <div className={styles.icon}>
            <Icon marginBottom={0} />
          </div>
        </div>
      </button>
      <Reveal id={`${id}-accordion-item`} focus={expanded} marginTop={3}>
        {expanded && (
          <div
            className={cn(
              styles.itemContent,
              getMarginBottomClass(marginBottom)
            )}
            {...rest}
          >
            {children}
          </div>
        )}
      </Reveal>
    </div>
  );
};

AccordionItem.displayName = 'AccordionItem';

AccordionItem.propTypes = {
  id: PropTypes.string,
  onToggle: PropTypes.func,
  children: PropTypes.node,
  expanded: PropTypes.bool,
  type: PropTypes.oneOf([AccordionItemType.LARGE]),
  iconSlot: PropTypes.node,
  title: PropTypes.string.isRequired,
  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
};

export { AccordionItem };

export default AccordionItem;
